<template>
  <div class="checkout__content">
    <img :src="logo" width="80" alt="Hauseful" class="checkout__logo">
    <CheckoutInfo v-if="!hasPaymentType">
      <p>Você selecionou o plano <strong>{{ plan }}</strong> com a frequência de <strong>{{ frequency }}</strong>.</p>
      <p>Agora, selecione a quantidade de usuários que utilizarão o sistema.</p>
      <v-select v-model="planAmount" @change="setPlanAmount" :label="selectUsersLabel" :items="values" outlined />
    </CheckoutInfo>
    <CheckoutNavigation v-else @setPaymentType="setPaymentType" :paymentType="paymentType" :planAmount="planAmountTotal" />
  </div>
</template>

<script>
import CheckoutInfo from '../fragments/CheckoutInfo.vue'
import CheckoutNavigation from '../fragments/CheckoutNavigation.vue'

export default {
  name: 'CheckoutPaymentHeader',

  props: {
    paymentType: {
      type: String,
    },

    plans: {
      type: Object,
    },

    plan: {
      type: String,
    },

    frequency: {
      type: String,
    },
  },

  components: {
    CheckoutInfo,
    CheckoutNavigation,
  },

  computed: {
    hasPaymentType() {
      return this.paymentType !== null
    },
  },

  methods: {
    setPaymentType(type) {
      this.$emit('setPaymentType', type)
    },

    doTheMath(users, formatAsCurrency = false) {
      const plan = this.plans[this.plan]
      const extra = this.extraUserValues[this.plan]
      const planAmount = plan[this.frequency]
      const extraAmount = extra[this.frequency]

      // Até 5 usuários inclusos no valor do plano
      let finalValue = planAmount
      if (users > 6) finalValue += (users - 6) * extraAmount
      if (formatAsCurrency) return finalValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      else return finalValue
    },

    setPlanAmount() {
      let multiplier = 1

      switch (this.frequency) {
        case 'mensal':
          multiplier = 1
          break
        case 'trimestral':
          multiplier = 3
          break
        case 'anual':
          multiplier = 12
          break
      }

      const total = this.planAmount * multiplier

      this.$emit('setPlanAmount', total)
      this.planAmountTotal = total
    },
  },

  data() {
    return {
      selectUsersLabel: 'Selecione o número de usuários',
      logo: require('@/assets/images/logohauseful.svg'),
      planAmount: null,
      planAmountTotal: null,
      values: [],
      extraUserValues: {
        gold: {
          mensal: 79.9,
          trimestral: 69.9,
          anual: 59.9
        },
        black: {
          mensal: 119.9,
          trimestral: 109.9,
          anual: 99.9
        }
      }
    }
  },

  mounted() {
    this.values = []

    for (let i = 5; i <= 9; i++) {
      this.values.push({
        text: `${i} usuários - ${this.doTheMath(i, true)}`,
        value: this.doTheMath(i),
      })
    }

    // if want to set default value
    // this.planAmount = this.values[0].value
  }
}
</script>

<style lang="scss" scoped>
.checkout {
  &__content {
    max-width: 780px;
  }

  &__logo {
    margin: 30px 0;
  }
}
</style>
